import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FieldDefinitionModel, FieldsFetcherService } from '@vdms-hq/fields';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'definitionForSelectedId',
  standalone: true,
})
export class DefinitionForSelectedIdPipe implements PipeTransform {
  private fields = inject(FieldsFetcherService);

  transform(id?: string | null): Observable<FieldDefinitionModel | null> {
    if (!id) {
      return of(null);
    }
    return this.fields
      .getAssetViewConfiguration$('asset_details')
      .pipe(map((config) => config.definitions.find((input) => input.id === id) ?? null));
  }
}
